<template>
    <div>
        <h5 class="heading-1">
            <span>PESQUISA</span>
        </h5>
        <b-row>
            <b-col>
                <b-form-group>
                    <label :class="{'required': atesto.codSituacao == 0}">
                        <strong>Classifique a entrega do material/serviço prestado:</strong>
                    </label>
                    <b-form-radio-group v-model="pergunta01" :disabled="atesto.codSituacao != 0">
                        <b-form-radio value="1">
                            <strong>
                                <span class="text-danger">RUIM</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="2">
                            <strong>
                                <span class="text-warning">REGULAR</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="3">
                            <strong>
                                <span class="text-success">BOM</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="4">
                            <strong>
                                <span class="text-primary">ÓTIMO</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <label :class="{'required' : atesto.codSituacao == 0}">
                        <strong>A respeito da qualidade do material/serviço, classifique:</strong>
                    </label>
                    <b-form-radio-group v-model="pergunta02" :disabled="atesto.codSituacao != 0">
                        <b-form-radio value="1">
                            <strong>
                                <span class="text-danger">RUIM</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="2">
                            <strong>
                                <span class="text-warning">REGULAR</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="3">
                            <strong>
                                <span class="text-success">BOM</span>
                            </strong>
                        </b-form-radio>
                        <b-form-radio value="4">
                            <strong>
                                <span class="text-primary">ÓTIMO</span>
                            </strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="atesto.codSituacao == 0">
            <b-col sm="12">
                <b-button
                    variant="danger"
                    v-if="!informarProblemas"
                    @click="informarProblemas = true"
                >Informar Problemas</b-button>
                <b-form-group v-if="informarProblemas">
                    <label>
                        <strong>Problemas</strong>
                    </label>
                    <b-form-textarea v-model="problemas" :rows="5" :disabled="false"></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object
		},

		atesto: {
			type: Object
		}
	},

	data() {
		return {
			pergunta01: 0,
			pergunta02: 0,
			problemas: null,
			informarProblemas: false
		}
	},

	created() {
		let perguntaTemp = this.value.avaliacoes.filter(item => {
			return item.perguntaId == 1
		})[0]

		this.pergunta01 = perguntaTemp ? perguntaTemp.respostaId : 0

		perguntaTemp = this.value.avaliacoes.filter(item => {
			return item.perguntaId == 2
		})[0]

		this.pergunta02 = perguntaTemp ? perguntaTemp.respostaId : 0
	},

	watch: {
		pergunta01() {
			this.atualizar()
		},

		pergunta02() {
			this.atualizar()
		},

		problemas() {
			this.atualizar()
		}
	},

	methods: {
		atualizar() {
			let retorno = {
				problemas: this.problemas,
				avaliacoes: []
			}
			retorno.avaliacoes[0] = {
				perguntaId: 1,
				respostaId: this.pergunta01
			}
			retorno.avaliacoes[1] = {
				perguntaId: 2,
				respostaId: this.pergunta02
			}
			this.$emit('input', retorno)
		}
	}
}
</script>
